/**
 * 过滤字符串为空的字段
 * @param {object} obj
 * @returns {object}
 */
export function filterEmptyParams(obj) {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (!(value === "" || value === null || value === undefined)) {
      newObj[key] = value;
    }
  }
  return newObj;
}

/**
 * 判断对象是否为空
 * @param {Object} obj
 * @return {boolean}
 */
 export function isObjectEmpty(obj) {
  return JSON.stringify(obj) === `{}`;
}
